import { Box, Stack, Typography } from "@mui/material";
import { UseQueryResult } from "@tanstack/react-query";
import { getStatusChip } from "../../UnitList/UnitsTable/columnDefs";
import { enqueueSnackbar } from "notistack";
import dayjs from "dayjs";
import { GetDetailsForLeaseResponse } from "@safelease/service-utilities";

type OccupancyMetadataProps = {
  leaseDetailsQuery: UseQueryResult<GetDetailsForLeaseResponse>;
};

function OccupancyMetadata({ leaseDetailsQuery }: OccupancyMetadataProps) {
  const { data: leaseDetails, isError } = leaseDetailsQuery;

  if (!leaseDetails || isError) {
    enqueueSnackbar("Failed to load occupancy details", { variant: "error" });
    return <Typography>ERROR: Failed to load occupancy details</Typography>;
  }

  return (
    <Stack spacing={1}>
      <Typography sx={{ fontWeight: 500, fontSize: 24 }}>Unit: {leaseDetails.unitName}</Typography>
      <Box>{getStatusChip(leaseDetails.status, "detailsPage")}</Box>
      <Typography>
        <span style={{ color: "#667085" }}>Tenant name</span> {leaseDetails.tenantName}
      </Typography>
      <Typography>
        <span style={{ color: "#667085" }}>Email</span> {leaseDetails.tenantEmail}
      </Typography>
      <Typography>
        <span style={{ color: "#667085" }}>Move-in date</span>{" "}
        {leaseDetails.moveInDate ? dayjs(leaseDetails.moveInDate).format("MM/DD/YYYY") : "N/A"}
      </Typography>
    </Stack>
  );
}

export { OccupancyMetadata };
